import React from 'react';
import _ from 'lodash';

import { FieldComponent } from '@jutro/components';

class SgCheckbox extends FieldComponent {
    static propTypes = {
        ...FieldComponent.propTypes,
    };

    componentDidMount() {
        const {
            id,
            modelVM,
            path,
            onValidate
        } = this.props;

        if (onValidate) {
            onValidate(_.get(modelVM, path).aspects.valid, id);
        }
    }

    componentDidUpdate(prevData) {
        const {
            id,
            modelVM,
            path,
            onValidate,
            selectedValue
        } = this.props;
        const valueChanged = !_.isEqual(selectedValue, prevData.selectedValue);
        if (onValidate && valueChanged) {
            const isValid = _.get(modelVM, path).aspects.valid;
            onValidate(isValid, id);
        }
    }

    renderControl() {
        this.handleChange = (el) => {
            this.props.onValueChange(el.target.checked);
        };

        return (
            <div className={this.props.controlClassName}>
                <div key={this.props.id} className="sgCheckboxButton">
                    <input
                        id={`checkbox_${this.props.id}`}
                        name={`checkbox_${this.props.name}`}
                        value={this.props.value}
                        checked={this.props.value}
                        type="checkbox"
                        onChange={this.handleChange}
                    />
                    <label
                        htmlFor={`checkbox_${this.props.id}`}
                        className={`${this.props.imageClass} ${this.props.value ? 'checked' : ''}`}
                        tabIndex="-1"
                    >
                        <span>{this.props.name}</span>
                    </label>
                </div>
            </div>
        );
    }

    render() {
        return super.render();
    }
}

export default SgCheckbox;
